import shared from "../agencies-sections.module.css"

const Info = () => {
	return (
		<section id="agencies-intro" className={shared.introSection} aria-labelledby="agencies-intro-heading">
			<div className={`container ${shared.sectionContainer}`}>
				<div className={shared.introGrid}>
					<div className={shared.introCopy}>
						<div className={shared.label}>Platform</div>
						<h2 id="agencies-intro-heading">Your PSA, Supercharged with Growth.</h2>
					</div>
					<p className={shared.bodyLg}>
						Go beyond traditional PSA. Our platform is natively integrated with the TechCore Network — actively
						turning your underutilized bench into revenue and giving your senior consultants a direct channel to
						the startups who need them most. Manage your entire agency in one place: people, projects, time
						tracking, and invoicing — while the platform quietly drives growth in the background.
					</p>
				</div>
			</div>
		</section>
	)
}

export default Info
